import { SxProps, Theme } from "@mui/material";

export default (theme: Theme): Record<string, SxProps<Theme>> => ({
  container: {
    displayPrint: "none",
    position: "relative",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "var(--rhythm)",
    height: "calc(4 * var(--rhythm))",
    p: "0 var(--rhythm)",
    [theme.breakpoints.down("md")]: {
      justifyContent: "center",
      height: "calc(3 * var(--rhythm))",
      background: "var(--color-white)",
    },
  },

  hamburger: {
    display: "none",
    [theme.breakpoints.down("md")]: {
      display: "block",
      position: "absolute",
      top: "calc(0.5 * var(--rhythm))",
      left: "calc(0.5 * var(--rhythm))",
      width: "calc(2 * var(--rhythm))",
      height: "calc(2 * var(--rhythm))",
      p: 0,
    },
  },

  logo: {
    display: "none",
    [theme.breakpoints.down("md")]: {
      display: "block",
      height: "calc(1.5 * var(--rhythm))",
    },
  },

  figure: {
    flexDirection: "column",
    alignItems: "flex-start",
    m: 0,
    p: "var(--rhythm)",
    img: {
      height: "var(--rhythm)",
    },
    figcaption: {
      fontSize: "var(--font-size-xs)",
    },
  },

  subtitle: {
    paddingX: "var(--rhythm)",
  },

  alert: {
    fontSize: "var(--font-size-m)",
    borderLeft: "none",
    borderRight: "none",
    borderRadius: 0,
  },

  reset: {
    height: "calc(2 * var(--rhythm))",
    p: "0 var(--rhythm)",
    "&.MuiIconButton-root": {
      position: "absolute",
      right: "calc(0.5 * var(--rhythm))",
      width: "calc(2 * var(--rhythm))",
    },
  },

  close: {
    position: "absolute",
    top: "calc(0.5 * var(--rhythm))",
    right: "calc(0.5 * var(--rhythm))",
    width: "calc(2 * var(--rhythm))",
    height: "calc(2 * var(--rhythm))",
    p: 0,
  },

  languages: {
    minHeight: "calc(2 * var(--rhythm))",
    background: "transparent",
    ".MuiSelect-select": {
      padding: "calc(0.25 * var(--rhythm)) calc(1.5 * var(--rhythm)) calc(0.25 * var(--rhythm)) calc(0.5 * var(--rhythm)) !important",
      fontSize: "var(--font-size-m)",
      background: "transparent",
    },
    ".MuiSvgIcon-root": {
      right: 0,
    },
  },

  sidebar: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "300px",
    height: "100vh",
    background: "var(--color-white)",
    transition: "margin-left 0.25s ease",
    zIndex: 10000,
  },
});
